export function numberFromString(str) {
   if(str) {
    var txt = str;
    var numb = txt.match(/\d/g);
    if(numb) {
      return numb.join("");
    }
   }
  }